module.exports = __webpack_public_path__ + "img/logo-vertical.a4846937.svg";